import { useRef } from "react";
import AddOne from "../components/AddOne";
import AddTwo from "../components/AddTwo";
import AdVideo from "../components/AdVideo";
import Banner from "../components/Banner";
import BannerTwo from "../components/BannerTwo";
import Calendly from "../components/Calendly";
import CaseStudies from "../components/CaseStudies";
import Experience from "../components/Experience";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import GrowBusiness from "../components/GrowBusiness";
import GrowthProcess from "../components/GrowthProcess";
import HeroSection from "../components/HeroSection";
import OurClients from "../components/OurClients";
import Portfolio from "../components/Portfolio";
import Revenue from "../components/Revenue";
import Testimonials from "../components/Testimonials";
import TopIndustry from "../components/TopIndustry";
import WhyNeuroid from "../components/WhyNeuroid";
import GoToTop from "../components/GoToTop";

const Home = () => {

    const targetRef = useRef(null);
    const containerRef = useRef(null);

    const handleClick = () => {
        const phoneNumber = "917223871544"; // Replace with your number (with country code, no '+' or '-' or spaces)
        const message = "Hello, I'm interested in your services!"; // Optional message
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(url, '_blank'); // Opens in a new tab
        // targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <div style={styles.container} ref={containerRef}>
            <HeroSection handleClick={handleClick} />
            <TopIndustry />
            {/* <OurClients /> */}
            <Revenue handleClick={handleClick} />
            <CaseStudies />
            <AddOne handleClick={handleClick} />
            {/* <AdVideo /> */}
            {/* <AddOne handleClick={handleClick} /> */}
            <Portfolio />
            <AddOne handleClick={handleClick} />
            <Banner />
            <AddOne handleClick={handleClick} />
            {/* <Testimonials /> */}
            <BannerTwo />
            <AddOne handleClick={handleClick} />
            <GrowthProcess />
            <WhyNeuroid />
            <AddOne handleClick={handleClick} />
            <Experience />
            <AddTwo handleClick={handleClick} />
            <GrowBusiness />
            <Faq />
            <AddOne color="white" handleClick={handleClick} />
            <div ref={targetRef} className="calendly">
                <Calendly handleClick={handleClick} />
            </div>
            <Footer />

            <GoToTop containerRef={containerRef} />
        </div>
    )
}

const styles = {
    container: {
        maxHeight: '100vh',
        // overflowX: 'hidden',
        overflow: 'auto',
    }
}

export default Home;